import SpotifyWebApi from 'spotify-web-api-node';

export const spotifyApi = new SpotifyWebApi({
  clientId: '74c723c7b3c741a1a2246433208896f9'
});
